/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Didnt_HappenInputs */

const en_confirm_didnt_happen = /** @type {(inputs: Confirm_Didnt_HappenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lesson didn’t happen`)
};

const he_confirm_didnt_happen = /** @type {(inputs: Confirm_Didnt_HappenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השיעור לא התקיים`)
};

/**
* | output |
* | --- |
* | "The lesson didn’t happen" |
*
* @param {Confirm_Didnt_HappenInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_didnt_happen = /** @type {((inputs?: Confirm_Didnt_HappenInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Didnt_HappenInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_didnt_happen(inputs)
	return he_confirm_didnt_happen(inputs)
});